import React, {useEffect, useState} from "react";
import {observer} from "mobx-react";
import {Alert, Badge, Card, Spinner, Button, Table} from "react-bootstrap";
import {reportsApi} from "../../../../api/reports.js";
import {ReportPageShell, DateRangeFilter} from "./ReportLayout.jsx";
import {exportTableToCsv, openTablePrintWindow} from "./exportUtils.js";

function AdminPayoutsReportPage() {
    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const load = async () => {
        setLoading(true);
        setError("");
        try {
            const resp = await reportsApi.getPayouts({dateFrom, dateTo});
            setData(resp);
        } catch (e) {
            console.error(e);
            setError("Failed to load report.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        load();
    }, []);

    return (
        <ReportPageShell title="Payouts (Estimated)" subtitle="Totals per tax authority derived from completed orders.">
            <DateRangeFilter
                dateFrom={dateFrom}
                dateTo={dateTo}
                onChange={(field, val) => field === "dateFrom" ? setDateFrom(val) : setDateTo(val)}
                onApply={load}
            />
            {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
            {loading && (
                <div className="d-flex align-items-center my-4">
                    <Spinner animation="border" size="sm" className="me-2" />
                    <span>Loading...</span>
                </div>
            )}
            {!loading && data && (
                <Card className="dashboard-panel mt-3" id="payouts-table">
                    <Card.Header className="bg-white d-flex justify-content-between align-items-center">
                        <strong>Payouts by Tax Authority</strong>
                        <div className="d-flex gap-2">
                            <Button size="sm" variant="outline-secondary" onClick={() => exportTableToCsv("payouts-table", "payouts.csv")}>Export CSV</Button>
                            <Button size="sm" variant="outline-secondary" onClick={() => openTablePrintWindow("payouts-table")}>Export PDF</Button>
                        </div>
                    </Card.Header>
                    <Card.Body className="p-0">
                        <Table hover responsive className="mb-0">
                            <thead>
                                <tr>
                                    <th>Tax Authority</th>
                                    <th className="text-end">Orders</th>
                                    <th className="text-end">Revenue (est.)</th>
                                    <th className="text-end">Product Fees</th>
                                    <th className="text-end">Service Fees</th>
                                    <th className="text-end">Tax</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.rows.map((row) => (
                                    <tr key={row.taxAuthorityId}>
                                        <td>{row.taxAuthorityName}</td>
                                        <td className="text-end">{row.orders}</td>
                                        <td className="text-end">${row.revenue.toFixed(2)}</td>
                                        <td className="text-end">${row.productFees.toFixed(2)}</td>
                                        <td className="text-end">${row.serviceFees.toFixed(2)}</td>
                                        <td className="text-end">${row.tax.toFixed(2)}</td>
                                    </tr>
                                ))}
                                {!data.rows.length && (
                                    <tr><td colSpan={6} className="text-center text-muted py-3">No data</td></tr>
                                )}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            )}
        </ReportPageShell>
    );
}

export default observer(AdminPayoutsReportPage);
